import type { RigoApi } from "./contract";
import { createMockApi } from "./mock";
import { createHttpApi } from "./http";

export type { RigoApi };

/**
 * The single API instance used by the query hooks. The comparison is on `import.meta.env` itself
 * because the build replaces that with a constant: it is what lets a deployed bundle leave the demo
 * data out, rather than carry it unreachable.
 */
export const api: RigoApi =
  import.meta.env.VITE_API_MODE === "http" ? createHttpApi("/api/v1") : createMockApi();
